import {
  enqueueSnackbar,
  OptionsObject,
  SnackbarKey,
  VariantType,
  closeSnackbar as noCloseSnackbar
} from "notistack";

export const showSnackbar = (message: string, variant: VariantType = 'default', option ?: OptionsObject): SnackbarKey => {
  if (!message) {
     console.log('Error: '+message)
     return
  }
  return enqueueSnackbar(message, { variant, ...option });
}

export const closeSnackbar = (snackbarId?:SnackbarKey) => {
  return noCloseSnackbar(snackbarId)
}